module.exports = __webpack_public_path__ + "static/media/neuter-avatar.d1049fd2.svg";